// Mantine 8 throws when two options share a value, which a point listed under two properties would do
export const dropRepeatedSelectValues = <TItem extends { value: string }>(
  groups: { group: string; items: TItem[] }[],
) => {
  const seenValues = new Set<string>()

  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => {
        if (seenValues.has(item.value)) return false

        seenValues.add(item.value)

        return true
      }),
    }))
    .filter((group) => group.items.length > 0)
}
